import { PRODUCT_META } from '@gb-ticket/shared-types';

export const ONBOARDING_ROOT = PRODUCT_META.onboarding.pathPrefix;
export const ONBOARDING_TEMPLATES_PATH = `${ONBOARDING_ROOT}/vorlagen`;
export const ONBOARDING_CASES_PATH = `${ONBOARDING_ROOT}/vorgaenge`;

export function onboardingTemplatePath(id: string): string {
  return `${ONBOARDING_TEMPLATES_PATH}/${id}`;
}

export function onboardingCasePath(id: string): string {
  return `${ONBOARDING_CASES_PATH}/${id}`;
}
